// Maps the user-facing section names (see BottomSheet) to CMS taxonomy
// primary section ids used by the story-feed-query API.
//
// A value ending in `*` is a wildcard match on the section and all of its
// subsections. An exact path (e.g. '/sport/six-nations') matches only that
// section. The CMS paths here are a first guess and may need correcting
// against the real taxonomy.
export const SECTION_CMS_MAP = {
  Business: '/business*',
  Crime: '/crime-and-law*',
  Culture: '/culture*',
  Environment: '/environment*',
  Health: '/health*',
  Ireland: '/ireland*',
  'Life-style': '/life-style*',
  Opinion: '/opinion*',
  Podcasts: '/podcasts*',
  Politics: '/politics*',
  Property: '/property*',
  Science: '/science*',
  Sport: '/sport*',
  Technology: '/technology*',
  World: '/world*',
};

function toClause(cmsId) {
  // Wildcard paths need their slashes escaped for the Lucene query syntax;
  // exact paths are quoted instead (mirrors the reference Ruby query).
  if (cmsId.endsWith('*')) {
    return `taxonomy.primary_section._id:${cmsId.replaceAll('/', '\\/')}`;
  }
  return `taxonomy.primary_section._id:"${cmsId}"`;
}

// Builds the story-feed query string for a list of user sections, e.g.
// (taxonomy.primary_section._id:\/technology* OR ...). Returns null when
// no section maps to a CMS id.
export function buildSectionsQuery(sections) {
  const clauses = sections
    .map((section) => SECTION_CMS_MAP[section])
    .filter(Boolean)
    .map(toClause);

  return clauses.length > 0 ? `(${clauses.join(' OR ')})` : null;
}
